import { CountryEntry } from './CountryEntry';

export const countriesDe: CountryEntry[] = [
  {
    name: 'Belgien',
    code: 'BE'
  },
  {
    name: 'Bulgarien',
    code: 'BG'
  },
  {
    name: 'Deutschland',
    code: 'DE'
  },
  {
    name: 'Dänemark',
    code: 'DK'
  },
  {
    name: 'Estland',
    code: 'EE'
  },
  {
    name: 'Finnland',
    code: 'FI'
  },
  {
    name: 'Frankreich',
    code: 'FR'
  },
  {
    name: 'Griechenland',
    code: 'GR'
  },
  {
    name: 'Irland',
    code: 'IE'
  },
  {
    name: 'Island',
    code: 'IS'
  },
  {
    name: 'Italien',
    code: 'IT'
  },
  {
    name: 'Kroatien',
    code: 'HR'
  },
  {
    name: 'Lettland',
    code: 'LV'
  },
  {
    name: 'Liechtenstein',
    code: 'LI'
  },
  {
    name: 'Litauen',
    code: 'LT'
  },
  {
    name: 'Luxemburg',
    code: 'LU'
  },
  {
    name: 'Malta',
    code: 'MT'
  },
  {
    name: 'Niederlande',
    code: 'NL'
  },
  {
    name: 'Norwegen',
    code: 'NO'
  },
  {
    name: 'Polen',
    code: 'PL'
  },
  {
    name: 'Portugal',
    code: 'PT'
  },
  {
    name: 'Rumänien',
    code: 'RO'
  },
  {
    name: 'Schweden',
    code: 'SE'
  },
  {
    name: 'Schweiz',
    code: 'CH'
  },
  {
    name: 'Slowakei',
    code: 'SK'
  },
  {
    name: 'Slowenien',
    code: 'SI'
  },
  {
    name: 'Spanien',
    code: 'ES'
  },
  {
    name: 'Tschechien',
    code: 'CZ'
  },
  {
    name: 'Ungarn',
    code: 'HU'
  },
  {
    name: 'Vereinigtes Königreich',
    code: 'GB'
  },
  {
    name: 'Zypern',
    code: 'CY'
  },
  {
    name: 'Österreich',
    code: 'AT'
  }
];
